export { default } from './TestimonialsBlock'
